<template>

</template>

<script>
    export default {
        data: function () {
            return {
                dropdownActive: false,
                popupActive: false,
                ignoreIconClick: false
            }
        },
        methods: {
            onFocusOut: function () {
                setTimeout(() => {
                    this.dropdownActive = false;
                    this.popupActive = false;
                }, 300);
            },
            nameClick: function () {
                this.dropdownActive = !this.dropdownActive;
            },
            iconMouseOver: function () {
                this.popupActive = true;
                this.ignoreIconClick = true;
            },
            iconMouseLeave: function () {
                this.popupActive = false;
            },
            iconClick: function () {
                if (!this.ignoreIconClick) {
                    this.popupActive = !this.popupActive;
                }
                this.ignoreIconClick = false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Dropdown.vue